<template>
    <div>
      <v-card class="grey lighten-3">
        <v-flex xs12 lg6 class="ma-auto pa-2">
          <v-text-field solo append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-flex>

        <v-data-table class="no-shadow card-r" v-bind:headers="headers" v-bind:items="items" v-bind:search="search" v-bind:pagination="pagination" hide-actions>
            <template slot="headers" slot-scope="props">
              <tr >
                <th class="textColor font-weight-bold"v-for="(header, index) in props.headers" :key="header.text"
                    :class="['column', 'subheading' , index === 0? 'text-xs-left': 'text-xs-left']">
                  {{ header.text }}
                </th>
                <th>
                </th>
              </tr>
            </template>
            <template class="body-2" slot="items" slot-scope="props">
              <td v-for="(header, index) in headers" :key="index" :class="[ index === 0? 'text-xs-left': 'text-xs-left', 'body-2']" v-if="header.value!==''">
               
                  <div v-if="header.text!='Status'">
                    {{renderData(props.item, header)}}
                  </div>
                  <div v-if="header.text=='Status'" class="sessss tabel-slc">
                    <v-select solo
                        v-if="props.item.status!='paid'"
                        v-model="props.item.status"
                        :items="actions"
                        item-text="props.item.status"
                        item-value="props.item.status"
                        @change="showpopup(props.item.id,props.item.status,props.item.request_amount)"
                        persistent-hint
                        return-object
                        single-line>
                    </v-select>
                        
                    <div class="grey" v-if="props.item.status=='paid'">{{props.item.status}}</div>
                    <confirm-withdraw></confirm-withdraw>
                  </div>

                  <!-- Popup for get the message frpm super admin -->

                  <!-- Popup for get the message frpm super admin -->
              </td>

              <td class="text-xs-center pa-0">
                      <!-- <v-btn icon>
                    <v-icon small  class="" @click.native="$emit('login',props.item.club_Id)">input</v-icon>
                      </v-btn> -->
                    <!-- <v-btn icon>
                          <v-icon small class=""  @click.native="$emit('view',props.item.club_Id)" color="green">visibility</v-icon>
                      </v-btn>-->
                      <!-- <v-btn class="teal" fab small dark @click.native="$emit('view', props.item)">
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <v-btn class="cyan" fab small @click.native="$emit('login', props.item)">
                        <v-icon>delete</v-icon>
                      </v-btn> -->
              </td>

            </template>
            <template slot="no-data">
              <span>
                  <p class="pt-2 blue--text subheading">   <v-icon medium class="blue--text" >info</v-icon>Nothing to display here :(</p>
              </span>
            </template>
        </v-data-table>
        <div class="text-xs-center pt-2" v-if="isNotEmpty">
            <v-pagination v-model="pagination.page" :length="pagination.pages" :total-visible="5" circle></v-pagination>
        </div>
         <v-dialog v-model="popup" max-width="500px">
                   <v-card>

                        <v-card-title class="headline">
                           Message
                        </v-card-title>
                       <v-card-text>
                          <v-text-field
                             name="Cvr"
                            label="Name"
                            v-model="withdrawName"
                           hint="Example : Money transfer for admin 2"
                           class=" input-group--focused mt-0 mt-0"
                          required
                         ></v-text-field>
                        <v-text-field
                            name="Cvr"
                            label="Message"
                           v-model="withdrawMessage"
                          hint="Example : I will transfer the money very shortly"
                          class=" input-group--focused mt-0 mt-0"
                          required
                           ></v-text-field>
                       </v-card-text>
                       <v-card-actions class="text-xs-right">
                         <v-btn color="primary" flat @click="popup=false">Close</v-btn>
                         <v-btn color="primary" flat @click="changestatus(popId,popStatus,popAmount)"> Send</v-btn>
                       </v-card-actions>
                   </v-card>
                   </v-dialog>
        </v-card>
    </div>

</template>
<script>
  /* eslint-disable */
  import confirmWithdraw from "@/components/confirmWithdraw.vue"
	import { dispatch } from "vuex";
  import api from "@/utils/backend-api"
	export default {
    name:"WithdrawRequestsTable",
		props: {
			headers: '',
			items: '',
      pagination: '',
      // popup:'false',
		},
		data () {
			return {
        search: "",
        actions:["pending","accept","paid"],
        popup:'false',
        popId:'',
        popStatus:'',
        popAmount:'',
        withdrawName:'',
        withdrawMessage:'',
        alertMsg:'',
        alertType:''
			}
		},
		methods: {
			renderData: (item, header) => {
				let val = "";
				if (header.value.includes('.')) {
					const vals = header.value.split('.')
					val = vals.reduce((acc, val) => acc[val], item)
				} else {
					val = item[header.value]
				}
				if (typeof val === "boolean") {
					val = val ? "Yes" : "No";
				}
				return val;
      },
      showpopup(id,status,amount){
          console.log(id,status,amount)
          this.popId=id
          this.popStatus=status
          this.popAmount=amount
          if(status!="pending"){
            this.popup=true
          }
      },
      changestatus(requestId,action,amount){
        console.log(requestId,action)
        // this.popup=false
        var Data=''
        switch(action){
          case "pending":break;
          case "accept":
                  Data={
                    "accept_name":this.withdrawName,
                    "accept_message":this.withdrawMessage,
                    "accept_amount":amount,
                    "id":requestId,
                    "status":action,
                    "request_amount":amount
                  }
                  break;
          case "paid":
                  Data={
                    "paid_name":this.withdrawName,
                    "paid_message":this.withdrawMessage,
                    "paid_amount":amount,
                    "id":requestId,
                    "status":action,
                    "request_amount":amount
                  }
                  break;
        }
        console.log(Data)

        var url = ""
        let self=this
        switch (Data.status) {
          case "accept":
            url = "driver/request/accept/" + Data.id;
            break;
          case "paid":
            url = "driver/request/paid/" + Data.id;
            break;
        }
        console.log("url")
        console.log(url)
        api.postData(url, Data).then(res => {
          if(res.status==200 || res.status==201){
            self.alertType="success"
            self.alertMsg="Successfully Sent"
            setTimeout(()=>{
              self.popup=false
            },1500);
          }else{
            self.alertType="error"
            self.alertMsg="Failed to submit"
          }
        })
        // this.$store.dispatch('changeWithdrawStatus',Data).then(res=>{
        //   debugger
        //   console.log(res)
        // })

      },
		},
		computed: {
			isNotEmpty () {
				return this.items && this.items.length > 0;
			}
    },
    created(){
        this.popup=false
    },
    components:{
      confirmWithdraw
    }
	}
</script>

<style>
.v-input{
  font-size:12px !important;
}
.v-list__tile__sub-title, .v-list__tile__title{
  /*font-size:13px !important;*/
  /*height:36px !important;*/
}
.sessss .v-select__slot{
  width:40px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/WithdrawRequestsTable.vue